export default __webpack_public_path__ + "static/media/content-4.1af96ad6.png";